var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgAlignmentCenter = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4.05C7.5 3.88431 7.63431 3.75 7.8 3.75H16.2C16.3657 3.75 16.5 3.88431 16.5 4.05V6.45C16.5 6.61569 16.3657 6.75 16.2 6.75H7.8C7.63431 6.75 7.5 6.61569 7.5 6.45V4.05Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 8.55C4.5 8.38431 4.63431 8.25 4.8 8.25H19.2C19.3657 8.25 19.5 8.38431 19.5 8.55V10.95C19.5 11.1157 19.3657 11.25 19.2 11.25H4.8C4.63432 11.25 4.5 11.1157 4.5 10.95V8.55Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 13.05C6 12.8843 6.13431 12.75 6.3 12.75H17.7C17.8657 12.75 18 12.8843 18 13.05V15.45C18 15.6157 17.8657 15.75 17.7 15.75H6.3C6.13432 15.75 6 15.6157 6 15.45V13.05Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 17.55C3 17.3843 3.13431 17.25 3.3 17.25H20.7C20.8657 17.25 21 17.3843 21 17.55V19.95C21 20.1157 20.8657 20.25 20.7 20.25H3.3C3.13431 20.25 3 20.1157 3 19.95V17.55Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgAlignmentCenter);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/alignment-center.12691ff033d4e685bd869288f35552ea.svg";